/* ALIA — global.js : menu drawer, cart drawer, tabs, carousel, variants, AJAX cart */
(function () {
  'use strict';

  /* ---------- Drawers (mobile menu + cart) ---------- */
  function openDrawer(el) { el.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer(el) { el.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      var d = document.querySelector(openBtn.getAttribute('data-drawer-open'));
      if (d) openDrawer(d);
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      var dd = e.target.closest('.drawer');
      if (dd) closeDrawer(dd);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Reviews tabs ---------- */
  document.querySelectorAll('[data-reviews]').forEach(function (root) {
    root.querySelectorAll('.reviews__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        root.querySelectorAll('.reviews__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        root.querySelectorAll('[data-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== id;
        });
      });
    });
  });

  /* ---------- Product rails ---------- */
  document.querySelectorAll('.rail-wrap').forEach(function (wrap) {
    var rail = wrap.querySelector('.product-rail');
    var bar = wrap.querySelector('.rail-progress__bar');
    if (!rail) return;
    function scrollByCard(dir) {
      var card = rail.firstElementChild;
      var amt = card ? card.getBoundingClientRect().width + 20 : 300;
      rail.scrollBy({ left: amt * dir, behavior: 'smooth' });
    }
    wrap.querySelectorAll('.rail-nav--prev').forEach(function (b) { b.addEventListener('click', function () { scrollByCard(-1); }); });
    wrap.querySelectorAll('.rail-nav--next').forEach(function (b) { b.addEventListener('click', function () { scrollByCard(1); }); });
    if (bar) {
      rail.addEventListener('scroll', function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var ratio = max > 0 ? rail.scrollLeft / max : 0;
        var visible = rail.clientWidth / rail.scrollWidth;
        bar.style.width = Math.max(visible * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (ratio * (100 / Math.max(visible, .12) - 100)) + '%)';
      });
    }
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.getAttribute('data-img');
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    q.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Variant selection on product form ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = JSON.parse(form.getAttribute('data-variants') || '[]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var atc = form.querySelector('[data-atc]');
    var selected = {};

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        if (btn.classList.contains('is-active')) selected[group.getAttribute('data-option-index')] = btn.getAttribute('data-value');
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          selected[group.getAttribute('data-option-index')] = btn.getAttribute('data-value');
          updateVariant();
        });
      });
    });

    function updateVariant() {
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === undefined || selected[i] === opt; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = formatMoney(match.price, match.compare_at_price);
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.getAttribute('data-add-label') : atc.getAttribute('data-sold-label');
      }
    }
  });

  function formatMoney(price, compare) {
    var sym = (window.ALIA && window.ALIA.currency) || 'LE';
    function fmt(c) { return sym + ' ' + (c / 100).toLocaleString(undefined, { minimumFractionDigits: 0 }); }
    if (compare && compare > price) {
      return '<span class="price price--on-sale"><span class="price__regular">' + fmt(price) +
        '</span> <s class="price__compare">' + fmt(compare) + '</s></span>';
    }
    return '<span class="price"><span class="price__regular">' + fmt(price) + '</span></span>';
  }

  /* ---------- AJAX add to cart ---------- */
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    });
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        refreshCartCount();
        renderCartDrawer();
        var d = document.querySelector('#CartDrawer');
        if (d) openDrawer(d);
      }).finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
      });
    });
  });

  /* quick add buttons on cards */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    var id = qa.getAttribute('data-quick-add');
    if (!id) return;
    qa.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      refreshCartCount(); renderCartDrawer();
      var d = document.querySelector('#CartDrawer'); if (d) openDrawer(d);
    }).finally(function () { qa.disabled = false; });
  });

  /* ---------- Cart drawer rendering ---------- */
  function renderCartDrawer() {
    var body = document.querySelector('[data-cart-body]');
    if (!body) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var sym = (window.ALIA && window.ALIA.currency) || 'LE';
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="btn" href="/collections/all">Start shopping</a></div>';
        return;
      }
      var lines = cart.items.map(function (it) {
        return '<div class="cart-line">' +
          '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/, '_120x$1') : '') + '" alt="">' +
          '<div><div class="cart-line__title">' + it.product_title + '</div>' +
          (it.variant_title ? '<div class="cart-line__variant">' + it.variant_title + '</div>' : '') +
          '<div class="cart-line__variant">Qty ' + it.quantity + '</div>' +
          '<button class="cart-line__remove" data-cart-remove="' + it.key + '">Remove</button></div>' +
          '<div>' + sym + ' ' + (it.final_line_price / 100).toLocaleString() + '</div></div>';
      }).join('');
      body.innerHTML = lines +
        '<div class="cart-foot"><div class="cart-foot__row"><span>Subtotal</span><span>' + sym + ' ' + (cart.total_price / 100).toLocaleString() + '</span></div>' +
        '<p class="cart-foot__note">Shipping &amp; taxes calculated at checkout.</p>' +
        '<a class="btn btn--block" href="/checkout">Checkout</a></div>';
    });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: rm.getAttribute('data-cart-remove'), quantity: 0 })
    }).then(function () { refreshCartCount(); renderCartDrawer(); });
  });

  // init drawer on first open
  document.querySelectorAll('[data-drawer-open="#CartDrawer"]').forEach(function (b) {
    b.addEventListener('click', renderCartDrawer);
  });
  refreshCartCount();
})();
